import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ScrollImage } from './ScrollImage';
import { ShieldCheck, Zap, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-slate-950 min-h-[100svh] flex flex-col py-8 sm:py-10" data-id="element-97">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-98">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-emerald-600 blur-[120px]" data-id="element-99"></div>
        <div className="absolute top-1/2 right-0 h-96 w-96 -translate-y-1/2 rounded-full bg-blue-900 blur-[120px]" data-id="element-100"></div>
      </div>

      <div className="container relative mx-auto px-4 w-full flex flex-1 flex-col items-center justify-center gap-4 sm:gap-6 max-w-3xl" data-id="element-101">
        {/* Top: badge + headline */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex flex-col items-center text-center w-full pt-2" data-id="element-102">
          <div className="mb-4 sm:mb-5 inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 px-3 py-1.5 text-[10px] sm:text-xs font-bold text-emerald-400 border border-emerald-500/20 uppercase tracking-wider" data-id="element-103">
            <ShieldCheck className="h-3.5 w-3.5 sm:h-4 sm:w-4" data-id="element-104" />
            KIT PSICÓLOGO DEPORTIVO
          </div>

          <h1 className="text-[28px] leading-[1.1] text-white sm:text-4xl md:text-5xl lg:text-6xl font-display tracking-tight" data-id="element-105">
            DEJÁ DE PREPARAR CADA SESIÓN{' '}
            <span className="text-emerald-400" data-id="element-106">DESDE CERO</span>
          </h1>
        </motion.div>

        {/* Middle: mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="w-full max-w-[338px] sm:max-w-xs md:max-w-sm relative z-10 py-2" data-id="element-107">
          <ScrollImage src="https://cdn.magicpatterns.com/uploads/2fusPuyD529iw7oHCdFpMC/Diseno_sin_titulo_(24).png" alt="KIT Psicólogo Deportivo" className="w-full h-auto drop-shadow-2xl object-contain max-h-[47vh] sm:max-h-[38vh]" data-id="element-108" />
        </motion.div>

        {/* Subheadline + benefit */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.15
      }} className="flex flex-col items-center text-center w-full" data-id="element-109">
          <p className="mx-auto mb-2 text-sm sm:text-base text-slate-300 max-w-xl leading-snug sm:leading-relaxed" data-id="element-110">
            Sistema práctico para evaluar, planificar e intervenir en el
            rendimiento mental de deportistas y equipos, sin improvisar tus
            sesiones.
          </p>

          <p className="text-xs sm:text-sm font-semibold text-emerald-400 flex items-center gap-1.5" data-id="element-111">
            <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4" data-id="element-112" />
            Menos tiempo armando. Más tiempo interviniendo.
          </p>
        </motion.div>

        {/* Bottom: CTA + trust */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="w-full flex flex-col items-center gap-3 z-20 pb-2" data-id="element-113">
          <Button className="w-full max-w-[300px] sm:max-w-sm text-base sm:text-lg py-4" data-id="element-114">
            QUIERO ACCEDER AL KIT
          </Button>

          <div className="flex items-center justify-center gap-4 text-[10px] sm:text-xs font-medium text-slate-400" data-id="element-115">
            <div className="flex items-center gap-1" data-id="element-116">
              <Zap className="h-3.5 w-3.5 text-emerald-500" data-id="element-117" />
              <span data-id="element-118">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-119">
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-500" data-id="element-120" />
              <span data-id="element-121">Pago único y seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}